const classNameCreator = icon => `icon-${icon}`;
const classCreator = icon => `.${classNameCreator(icon)}`;

export const nextIconName = isMobile => (isMobile ? 'next-arrow' : 'next');
export const prevIconName = isMobile => (isMobile ? 'back' : 'prev');

export const getNextIcon = (isMobile, isRtl) =>
  (isRtl ? classCreator(prevIconName(isMobile)) : classCreator(nextIconName(isMobile)));

export const getPrevIcon = (isMobile, isRtl) =>
  (isRtl ? classCreator(nextIconName(isMobile)) : classCreator(prevIconName(isMobile)));

